// extracted by mini-css-extract-plugin
module.exports = {"wzbr7vc":"wzbr7vc"};